import { render, staticRenderFns } from "./SpeechSynthesizer.vue?vue&type=template&id=573fa834&scoped=true&"
import script from "./SpeechSynthesizer.vue?vue&type=script&lang=ts&"
export * from "./SpeechSynthesizer.vue?vue&type=script&lang=ts&"
import style0 from "./SpeechSynthesizer.vue?vue&type=style&index=0&id=573fa834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573fa834",
  null
  
)

export default component.exports